import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(32.000000, 32.000000)">
        <path
          d="M0.0340909 0.0909081H9.13636L18.75 23.5455H19.1591L28.7727 0.0909081H37.875V35H30.7159V12.2784H30.4261L21.392 34.8295H16.517L7.48295 12.1932H7.19318V35H0.0340909V0.0909081Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
